export default {"src":"/_next/static/media/college8.b0ec25f8.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};